module.exports = __webpack_public_path__ + "img/up_double_gray.c7d3b452.svg";